// extracted by mini-css-extract-plugin
export var cartContainer = "_nh-4";
export var gray = "_nh-1";
export var itemContainer = "_nh-2";
export var itemDetails = "_nh-3";
export var strong = "_nh-0";